import { Appearance, ProductReference, ProductType, View } from '@/types';
import { assertDefined } from '@/utils/assertDefined';
import { fetchProductPrice } from '@/utils/http/fetchProductPrice';
import { getParams } from '@/utils/params';
import { createExternalBasketPayload } from './createExternalBasketPayload';

export function addToExternalBasket(
  sizes: Record<string, number>,
  productReference: ProductReference,
  productType: ProductType,
  appearance: Appearance,
  view: View
): Promise<void> {
  const params = getParams();

  // if this is not set in the external basket case we can't do anything so we throw an error
  if (!params.addToBasket) {
    return Promise.reject(
      new Error('Basket implementation not configured correctly, addBasketItemNg missing!')
    );
  }

  return fetchProductPrice(productReference.id).then((price) => {
    return Object.entries(sizes).reduce((promise, [sizeId, quantity]) => {
      const size = assertDefined(productType.sizes.find((s) => s.id === sizeId));

      // create external payload
      const payload = createExternalBasketPayload(
        productReference,
        appearance,
        productType,
        view,
        size,
        quantity,
        price
      );

      // we need them to be executed in order so we have to chain them
      return promise.then(
        () =>
          new Promise((resolve, reject) => {
            params.addToBasket(payload, (err?: unknown) => {
              if (err) {
                reject(err);
              } else {
                resolve();
              }
            });
          })
      );
    }, Promise.resolve());
  });
}
